export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/event/icon-quiz-q-1de3f339a67c20597003a2f3180b18c9.svg";